import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "batteryFilled"
const BatteryFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M22.125 6.75H21V19.5C21 20.328 20.328 21 19.5 21H4.5C3.672 21 3 20.328 3 19.5V6.75H1.875V5.25H22.125zM15.75 11.25V12.75H14.25V14.25H15.75V15.75H17.25V14.25H18.75V12.75H17.25V11.25zM5.25 12.75V14.25H9.75V12.75z"
            clipRule="evenodd"
          />
          <path d="M6.75 2.25C7.164 2.25 7.5 2.586 7.5 3V3.75H4.5V3C4.5 2.586 4.836 2.25 5.25 2.25zM18.75 2.25C19.164 2.25 19.5 2.586 19.5 3V3.75H16.5V3C16.5 2.586 16.836 2.25 17.25 2.25z" />
        </svg>
      }
    </span>
  )
}
export default BatteryFilledIcon
